import { initAnalytics } from '@foir/shell/analytics';
import { getConfig, loadConfig } from '@/lib/config';
import './styles.css';

// Load runtime config first (PostHog key + URLs all come from it),
// then init analytics and dynamically import the app so module-scope reads of
// getConfig() run after config is in place.
void loadConfig().then(async () => {
  const cfg = getConfig();
  initAnalytics({
    posthogKey: cfg.posthogKey,
    posthogHost: cfg.posthogHost,
    environment: cfg.environment,
  });
  const { mount } = await import('@/app');
  mount();
});
